import { render } from "./vlabelmanageadd.vue?vue&type=template&id=cfadf4c6&scoped=true"
import script from "./vlabelmanageadd.vue?vue&type=script&lang=js"
export * from "./vlabelmanageadd.vue?vue&type=script&lang=js"

import "./vlabelmanageadd.vue?vue&type=style&index=0&id=cfadf4c6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfadf4c6"]])

export default __exports__